import { ActionButtonText } from '@strata/react-buttons';
import { PageTitle } from '@strata/react-page-title';
import PropTypes from 'prop-types';

export const PriorAuthorizationHeader = ({ onClear }) => (
    <div style={{ display: 'flex', flexGrow: 1, justifyContent: 'space-between' }}>
        <PageTitle title="Prior Authorization Submission" />
        <ActionButtonText label="Clear All" onClick={onClear} className="margin__bottom--x-small" />
    </div>
);

PriorAuthorizationHeader.propTypes = {
    onClear: PropTypes.func.isRequired,
};
